import React from 'react';
import PropTypes from 'prop-types';
import values from 'lodash/values';
import ImmutablePropTypes from 'react-immutable-proptypes';
import AnalyticsConstants from '@bibliocommons/constants-analytics';

const SUPPORTED_CONTEXTS = values(AnalyticsConstants.CONTEXTS);

export default class AnalyticsContext extends React.PureComponent {
  constructor(props) {
    super(props);
    const { context, contextName, analyticsActions } = props;

    if (SUPPORTED_CONTEXTS.includes(contextName)) {
      analyticsActions.setContext(contextName, context);
    } else {
      throw new Error(`${contextName} is not a supported analytics context.`);
    }
  }

  componentDidUpdate() {
    const { context, contextName, analyticsActions } = this.props;
    analyticsActions.setContext(contextName, context);
  }

  componentWillUnmount() {
    const { contextName, analyticsActions } = this.props;
    analyticsActions.setContext(contextName, undefined);
  }

  render() {
    return null;
  }
}

AnalyticsContext.propTypes = {
  context: ImmutablePropTypes.map.isRequired,
  contextName: PropTypes.string.isRequired,
  analyticsActions: PropTypes.objectOf(PropTypes.func).isRequired
};
